import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { DatePicker, Flex, Input, Select, TimePicker, Typography, Upload, Button } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getClubs, getGyms, getTrainers } from 'src/store/Slices/DropDownSlice';
import { getServices } from 'src/store/Slices/AbonementsSlice';
import { scheduleAction } from 'src/store/Slices/Administrator/ScheduleSlice';
import dayjs from 'dayjs';
import { UploadOutlined } from '@ant-design/icons';



const CopyScheduleModal = ({ visible, setVisible, scheduleInfo, setPage, setPageSize, payload }) => {

    const dispatch = useDispatch()
    const [dateList, setDateList] = useState([])

    useEffect(() => {
        setDateList([])
    }, [visible])

    const disabledDate = (current) => {
        return current && dayjs(current).format('YYYY-MM-DD') === scheduleInfo?.date
    }

    const onClickSubmit = () => {
        dispatch(scheduleAction({
            flag: 'copy', value: {
                id: scheduleInfo?.id,
                dateList: dateList
            }
        })).then(() => {
            dispatch(scheduleAction({ flag: 'get', value: {...payload} })).then(() => {
                setVisible(false)
                setPage(1)
                setPageSize(20)
            })
        })
    }

    const onChange = (date, dateString) => {
        setDateList([...dateString])
    };

    return (
        <CModal
            alignment="center"
            visible={visible}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible(false) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    'Копирование тренировки'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={10} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Выбрерите даты</Typography.Title>
                            <DatePicker
                                multiple
                                onChange={onChange}
                                disabledDate={disabledDate}
                                maxTagCount="responsive"
                            />
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible(false) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton disabled={dateList.length === 0 || dateList[0] === ''} onClick={onClickSubmit} className='text-light'>
                    Подтвердить
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default CopyScheduleModal